"use strict";

import OrganizationBase from "../../views/Organization/OrganizationBase.vue";
import OrganizationPackages from "../../views/Organization/OrganizationPackages.vue";
import OrganizationMembers from "../../views/Organization/OrganizationMembers.vue";
import OrganizationEdit from "../../views/Organization/OrganizationEdit.vue";
import TeamListing from "../../views/Team/TeamListing.vue";
import TeamPackages from "../../views/Team/TeamPackages.vue";
import TeamMembers from "../../views/Team/TeamMembers.vue";

export default {
  path: "/organization/:slug",
  component: OrganizationBase,
  props: true,
  children: [
    {
      path: "",
      name: "organization_packages",
      component: OrganizationPackages
    },
    {
      path: "members",
      name: "organization_members",
      component: OrganizationMembers
    },
    {
      path: "edit",
      name: "organization_edit",
      component: OrganizationEdit,
      meta: {
        auth: true
      },
    },
    {
      path: "teams",
      name: "teams",
      component: TeamListing,
    },
    {
      path: "teams/:teamId/packages",
      name: "teams_packages",
      component: TeamPackages,
      props: true,
      meta: {
        auth: true
      },
    },
    {
      path: "teams/:teamId/members",
      name: "teams_members",
      component: TeamMembers,
      props: true,
      meta: {
        auth: true
      },
    }
  ]
};
